import useStyles from '../../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  getAvailableTargetFieldNatureOptions, getOrderedOptions,
  TargetFieldContext,
  VariableContext,
} from '../../../../../../services/common/CalculatorUtils';
import { useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CalculatorSelectInput from '../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import { hasOption } from '../../../../../../services/common/Utils';
import { Context } from "states/Store";


const ThirdPartyField = ({ fieldName, readOnly = false }) => {
  const { classes } = useStyles();
  const { selectedTargetFieldCategory } = useContext(TargetFieldContext);
  const { onVariableChangeCallBack, currentVariable } = useContext(
    VariableContext
  );
  const [state, ] = useContext(Context);

  const formMethods = useFormContext();
  const { setValue, clearErrors } = formMethods;

  const [
    availableTargetFieldNatureOptions,
    setAvailableTargetFieldNatureOptions,
  ] = useState();

  const hasOptionSubscription = useCallback((option) => {
    return hasOption(state?.accounts, state?.account?.id, option)
  }, [state?.account?.id, state?.accounts])

  useEffect(() => {
    setAvailableTargetFieldNatureOptions(
      getAvailableTargetFieldNatureOptions(selectedTargetFieldCategory, hasOptionSubscription)
    );
  }, [selectedTargetFieldCategory, hasOptionSubscription]);

  const onTargetFieldNatureChange = useCallback(
    (newValue) => {
      setValue(`${fieldName}.field`, '');
      clearErrors(`${fieldName}.field`, '');

      setValue(`${fieldName}.field_type`, '');
      clearErrors(`${fieldName}.field_type`, '');
    },
    [fieldName, setValue, clearErrors]
  );

  if (!_.isEmpty(availableTargetFieldNatureOptions)) {
    return (
      <>
        <div className={classes.variableDivider}> /</div>

        <CalculatorSelectInput
          fieldName={`${fieldName}.target_field_nature`}
          label={``}
          isRequired
          placeholder={i18next.t(
            `calculator.dialog.create.placeholder.selectValue`
          )}
          options={getOrderedOptions(availableTargetFieldNatureOptions)}
          onChange={(newValue) => {
            onTargetFieldNatureChange(newValue);
            onVariableChangeCallBack(currentVariable, 'target_field_nature');
          }}
          validate={() => {
            return null;
          }}
          variant="standard"
          labelVariant="standard"
          className={classes.inputPathVariableItem}
          disabled={readOnly}
        />
      </>
    );
  } else {
    return <></>;
  }
};

export default ThirdPartyField;